<template>
  <button
    type="button"
    class="au-eye"
    :aria-label="STRINGS.aria.labels.togglePasswordVisibility"
    :aria-pressed="pressed"
    @click="emit('toggle')"
  >
    <!-- eye-slash (password visible) -->
    <svg
      v-if="pressed"
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path
        d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-10-7-10-7a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 7 10 7a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
      />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
    <!-- eye (password hidden) -->
    <svg
      v-else
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  </button>
</template>

<script setup lang="ts">
import STRINGS from '@/constants/strings';

defineProps<{ pressed: boolean }>();

const emit = defineEmits<{ toggle: [] }>();
</script>
